export function findCityInfoById(id, fullAreaList) {
  let stack = []
  function dfs(list, pointer) {
    if (!list || !list[pointer]) {
      return false
    }
    stack.push(list[pointer])
    if (list[pointer].id === id) {
      // found !!!
      return true
    } else if (!dfs(list[pointer].districtList, 0)) {
      stack.pop()
      return dfs(list, pointer + 1)
    }
  }
  dfs(fullAreaList, 0)
  return stack
}
